export const debouncer = () => {
	let interval: number;
	return (action: CallableFunction, timeOut = 500) => {
		clearTimeout(interval);
		interval = setTimeout(action, timeOut);
	};
};
